import React, { useEffect, useRef, useState } from "react"
import EvaluationReportsFilters from "./EvaluationReportsComponents/EvaluationReportsFilters"
import EvaluationReportsTable from "./EvaluationReportsComponents/EvaluationReportsTable"
import PaginationComponent from "./BroadcastReportsComponents/PaginationComponent"
import axios from "axios"
import moment from "moment"

import configs from "config"
const { Url, type, version, apiVersion } = configs.client

import { useSelector, useDispatch } from "react-redux"
import UnAuthorizedPopup from "components/Common/UnAuthorized/UnAuthorizedPopup"
import EvaluationReportsActions from "./EvaluationReportsComponents/EvaluationReportsActions"
import { unAuthUser } from "store/actions"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

function EvaluationReports() {
  const { access, authorized, selectedTeams } = useSelector(state => ({
    access: state.Login.userAccess,
    authorized: state.Login.authorized,
    selectedTeams: state.Login.selectedTeams,
  }))

  const dispatch = useDispatch()

  const [isloading, setIsLoading] = useState(false)
  const [evaluationsData, setEvaluationsData] = useState([])

  const [selectedTeam, setSelectedTeam] = useState(null)
  const [selectedUser, setSelectedUser] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [chatNumber, setChatNumber] = useState("")

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [limit] = useState(10)

  const cancelTokenSource = useRef(null)

  const fetchEvaluationTableData = () => {
    let getBody = {}

    if (cancelTokenSource.current) {
      cancelTokenSource.current.cancel(
        "Operation canceled due to a new request."
      )
    }

    cancelTokenSource.current = axios.CancelToken.source()

    if (startDate) getBody.startDate = moment(startDate).format("MM-DD-YYYY")
    if (endDate) getBody.endDate = moment(endDate).format("MM-DD-YYYY")
    if (selectedTeam)
      getBody.selectedTeams = selectedTeam?.map(obj => obj.value).join(",")
    if (selectedUser)
      getBody.selectedUsers = selectedUser?.map(obj => obj.value).join(",")
    if (chatNumber && chatNumber.length >= 6) getBody.chatNumber = chatNumber

    // Pagination params
    getBody.page = currentPage
    getBody.limit = limit

    const fetchEvaluationURL = `${Url}/${apiVersion}/evaluation`

    setIsLoading(true)

    axios
      .get(fetchEvaluationURL, {
        params: getBody,
        headers: {
          "Content-Type": "application/json; charset=utf8",
          Authorization: `Bearer ${access}`,
        },
        cancelToken: cancelTokenSource.current.token,
      })
      .then(res => {
        setIsLoading(false)
        setEvaluationsData(res.data.data.sessions || [])

        // Set pagination info from response
        if (res.data.data.totalPages) {
          setTotalPages(res.data.data.totalPages)
        }
      })
      .catch(err => {
        setIsLoading(false)

        if (axios.isCancel(err)) {
          // console.log("Request canceled", err.message)
        } else {
          const status = err.response?.status

          if (
            status === 401 || //
            status === 0 ||
            !status
          ) {
            dispatch(unAuthUser())
          } else {
            const errorMessage =
              err.response?.data?.message || "Failed to load evaluation data."
            toast.error(errorMessage)
            console.error("Error fetching evaluation data:", err)
          }
        }
      })
  }

  useEffect(() => {
    if (selectedTeam && selectedTeam.length > 0) {
      setSelectedUser(null)
    }
  }, [selectedTeam])

  // Reset to page 1 when filters change
  useEffect(() => {
    setCurrentPage(1)
  }, [selectedUser, selectedTeam, startDate, endDate, chatNumber])

  useEffect(() => {
    fetchEvaluationTableData()
  }, [selectedUser, selectedTeam, startDate, endDate, currentPage, chatNumber])

  const handleResetFilters = () => {
    setSelectedTeam([])
    setSelectedUser([])
    setStartDate(null)
    setEndDate(null)
    setChatNumber("")
    setCurrentPage(1)
  }

  const isFiltered =
    selectedTeam?.length > 0 ||
    selectedUser?.length > 0 ||
    startDate !== null ||
    endDate !== null ||
    chatNumber?.length >= 6

  if (!authorized) {
    return <UnAuthorizedPopup />
  }

  return (
    <div className="user-setting-page">
      <div className="performance-page">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="mb-0">Evaluation Reports</h4>
          <EvaluationReportsActions
            isFiltered={isFiltered}
            handleResetFilters={handleResetFilters}
            evaluationsData={evaluationsData}
            selectedTeam={selectedTeam}
            selectedUser={selectedUser}
            startDate={startDate}
            endDate={endDate}
            access={access}
          />
        </div>

        <EvaluationReportsFilters
          selectedTeam={selectedTeam}
          setSelectedTeam={setSelectedTeam}
          selectedUser={selectedUser}
          setSelectedUser={setSelectedUser}
          startDate={startDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          endDate={endDate}
          chatNumber={chatNumber}
          setChatNumber={setChatNumber}
        />

        <EvaluationReportsTable
          isloading={isloading}
          evaluationsData={evaluationsData}
        />

        {totalPages > 1 && (
          <PaginationComponent
            currentPage={currentPage}
            totalPages={totalPages}
            setCurrentPage={setCurrentPage}
          />
        )}
      </div>
    </div>
  )
}

export default EvaluationReports
